var map = {
	"./Alerts & feedback/alert-circle.svg": 6299,
	"./Alerts & feedback/alert-hexagon.svg": 66241,
	"./Alerts & feedback/alert-octagon.svg": 25456,
	"./Alerts & feedback/alert-square.svg": 63418,
	"./Alerts & feedback/alert-triangle.svg": 50759,
	"./Alerts & feedback/announcement-02.svg": 22844,
	"./Alerts & feedback/announcement-03.svg": 12317,
	"./Alerts & feedback/bell-03.svg": 76283,
	"./Alerts & feedback/bell-04.svg": 44660,
	"./Alerts & feedback/bell-ringing-03.svg": 66680,
	"./Alerts & feedback/bell-ringing-04.svg": 61751,
	"./Alerts & feedback/notification-box.svg": 87725,
	"./Alerts & feedback/notification-message.svg": 91587,
	"./Alerts & feedback/notification-text.svg": 45539,
	"./Alerts & feedback/thumbs-down.svg": 4708,
	"./Alerts & feedback/thumbs-up.svg": 85599,
	"./Arrows/arrow-block-down.svg": 16068,
	"./Arrows/arrow-block-left.svg": 28579,
	"./Arrows/arrow-block-right.svg": 60422,
	"./Arrows/arrow-block-up.svg": 26751,
	"./Arrows/arrow-circle-down-left.svg": 80277,
	"./Arrows/arrow-circle-down-right.svg": 57144,
	"./Arrows/arrow-circle-down.svg": 5249,
	"./Arrows/arrow-circle-left.svg": 39770,
	"./Arrows/arrow-circle-right.svg": 65681,
	"./Arrows/arrow-circle-up-left.svg": 85272,
	"./Arrows/arrow-circle-up-right.svg": 15879,
	"./Arrows/arrow-circle-up.svg": 6366,
	"./Arrows/arrow-narrow-down-left.svg": 720,
	"./Arrows/arrow-narrow-down-right.svg": 94687,
	"./Arrows/arrow-narrow-down.svg": 32006,
	"./Arrows/arrow-narrow-left.svg": 15245,
	"./Arrows/arrow-narrow-right.svg": 26640,
	"./Arrows/arrow-narrow-up-left.svg": 81121,
	"./Arrows/arrow-narrow-up-right.svg": 48396,
	"./Arrows/arrow-narrow-up.svg": 17181,
	"./Arrows/arrow-square-down-left.svg": 87088,
	"./Arrows/arrow-square-down-right.svg": 3135,
	"./Arrows/arrow-square-down.svg": 17254,
	"./Arrows/arrow-square-left.svg": 30573,
	"./Arrows/arrow-square-right.svg": 88208,
	"./Arrows/arrow-square-up-left.svg": 99809,
	"./Arrows/arrow-square-up-right.svg": 85452,
	"./Arrows/arrow-square-up.svg": 54557,
	"./Arrows/arrows-triangle.svg": 74859,
	"./Arrows/chevron-down-double.svg": 17824,
	"./Arrows/chevron-down.svg": 67486,
	"./Arrows/chevron-left-double.svg": 87713,
	"./Arrows/chevron-left.svg": 9013,
	"./Arrows/chevron-right-double.svg": 49470,
	"./Arrows/chevron-right.svg": 60280,
	"./Arrows/chevron-selector-horizontal.svg": 88726,
	"./Arrows/chevron-selector-vertical.svg": 29708,
	"./Arrows/chevron-up-double.svg": 60257,
	"./Arrows/chevron-up.svg": 17205,
	"./Arrows/corner-down-left.svg": 34326,
	"./Arrows/corner-down-right.svg": 57589,
	"./Arrows/corner-left-down.svg": 37056,
	"./Arrows/corner-left-up.svg": 33715,
	"./Arrows/corner-right-down.svg": 91415,
	"./Arrows/corner-right-up.svg": 32680,
	"./Arrows/corner-up-left.svg": 35467,
	"./Arrows/corner-up-right.svg": 65518,
	"./Arrows/expand-01.svg": 47300,
	"./Arrows/expand-06.svg": 51979,
	"./Arrows/flip-forward.svg": 99165,
	"./Arrows/infinity.svg": 89444,
	"./Arrows/refresh-cw-01.svg": 69016,
	"./Arrows/refresh-cw-02.svg": 7851,
	"./Arrows/refresh-cw-05.svg": 59492,
	"./Arrows/reverse-left.svg": 76284,
	"./Arrows/reverse-right.svg": 32867,
	"./Arrows/switch-horizontal-01.svg": 69551,
	"./Arrows/switch-horizontal-02.svg": 90524,
	"./Arrows/switch-vertical-01.svg": 74889,
	"./Arrows/switch-vertical-02.svg": 13722,
	"./AudioEye/accessible-human.svg": 82431,
	"./AudioEye/ae-accessibility-help-desk.svg": 82750,
	"./AudioEye/ae-accessibility.svg": 67668,
	"./AudioEye/ae-accessible.svg": 60854,
	"./AudioEye/ae-ada.svg": 85120,
	"./AudioEye/ae-aoda.svg": 94997,
	"./AudioEye/ae-audits.svg": 2960,
	"./AudioEye/ae-banking-finance.svg": 67467,
	"./AudioEye/ae-bug.svg": 1378,
	"./AudioEye/ae-closed-captions.svg": 17768,
	"./AudioEye/ae-cms-integrations.svg": 55501,
	"./AudioEye/ae-color-contrast.svg": 71408,
	"./AudioEye/ae-dots-grid.svg": 33137,
	"./AudioEye/ae-dots-horizontal.svg": 33757,
	"./AudioEye/ae-dots-vertical.svg": 95547,
	"./AudioEye/ae-eaa.svg": 34351,
	"./AudioEye/ae-education.svg": 16798,
	"./AudioEye/ae-food-bev.svg": 35872,
	"./AudioEye/ae-france.svg": 67957,
	"./AudioEye/ae-germany.svg": 69407,
	"./AudioEye/ae-government.svg": 96417,
	"./AudioEye/ae-great-britain.svg": 14465,
	"./AudioEye/ae-healthcare.svg": 69273,
	"./AudioEye/ae-hearing-impairment.svg": 14183,
	"./AudioEye/ae-integrations.svg": 12829,
	"./AudioEye/ae-legal-compliance.svg": 37329,
	"./AudioEye/ae-legal.svg": 25831,
	"./AudioEye/ae-mobile-app-audits.svg": 91885,
	"./AudioEye/ae-motor-impairment.svg": 64646,
	"./AudioEye/ae-pause.svg": 12970,
	"./AudioEye/ae-reseller-partners.svg": 93614,
	"./AudioEye/ae-resource-hub.svg": 66482,
	"./AudioEye/ae-section-508.svg": 39783,
	"./AudioEye/ae-sort-ascending.svg": 9689,
	"./AudioEye/ae-sort-descending.svg": 58947,
	"./AudioEye/ae-unruh.svg": 25726,
	"./AudioEye/ae-video.svg": 99213,
	"./AudioEye/ae-wcag.svg": 28218,
	"./AudioEye/ae-web-accessibility-checker.svg": 60819,
	"./Charts/bar-chart-01.svg": 18703,
	"./Charts/bar-chart-02.svg": 39676,
	"./Charts/bar-chart-03.svg": 29149,
	"./Charts/bar-chart-07.svg": 88353,
	"./Charts/bar-chart-08.svg": 77462,
	"./Charts/bar-chart-09.svg": 41287,
	"./Charts/bar-chart-10.svg": 9257,
	"./Charts/bar-chart-11.svg": 5016,
	"./Charts/bar-chart-12.svg": 55755,
	"./Charts/bar-chart-square-01.svg": 11429,
	"./Charts/bar-chart-square-02.svg": 79654,
	"./Charts/bar-chart-square-03.svg": 84983,
	"./Charts/bar-line-chart.svg": 75598,
	"./Charts/chart-breakout-circle.svg": 90462,
	"./Charts/chart-breakout-square.svg": 2515,
	"./Charts/horizontal-bar-chart-01.svg": 59520,
	"./Charts/horizontal-bar-chart-02.svg": 50259,
	"./Charts/horizontal-bar-chart-03.svg": 36034,
	"./Charts/line-chart-down-01.svg": 71793,
	"./Charts/line-chart-down-02.svg": 7746,
	"./Charts/line-chart-down-03.svg": 21971,
	"./Charts/line-chart-up-01.svg": 22900,
	"./Charts/line-chart-up-02.svg": 71111,
	"./Charts/line-chart-up-03.svg": 24246,
	"./Charts/pie-chart-02.svg": 84287,
	"./Charts/pie-chart-03.svg": 55854,
	"./Charts/pie-chart-04.svg": 54353,
	"./Charts/presentation-chart-01.svg": 61216,
	"./Charts/trend-down-01.svg": 63399,
	"./Charts/trend-down-02.svg": 91892,
	"./Charts/trend-up-01.svg": 97582,
	"./Charts/trend-up-02.svg": 45933,
	"./Communication/annotation-alert.svg": 49998,
	"./Communication/annotation-check.svg": 62268,
	"./Communication/annotation-dots.svg": 472,
	"./Communication/annotation-heart.svg": 92792,
	"./Communication/annotation-info.svg": 200,
	"./Communication/annotation-plus.svg": 36340,
	"./Communication/annotation-question.svg": 43528,
	"./Communication/annotation-x.svg": 59428,
	"./Communication/annotation.svg": 56715,
	"./Communication/inbox-01.svg": 59272,
	"./Communication/mail-02.svg": 41564,
	"./Communication/mail-05.svg": 69219,
	"./Communication/message-alert-square.svg": 14504,
	"./Communication/message-chat-square.svg": 76148,
	"./Communication/message-check-square.svg": 5282,
	"./Communication/message-dots-square.svg": 9166,
	"./Communication/message-heart-square.svg": 1430,
	"./Communication/message-notification-square.svg": 99305,
	"./Communication/message-plus-square.svg": 49302,
	"./Communication/message-question-square.svg": 61914,
	"./Communication/message-smile-square.svg": 19758,
	"./Communication/message-square-01.svg": 39341,
	"./Communication/message-square-02.svg": 28622,
	"./Communication/message-text-square-01.svg": 89015,
	"./Communication/message-text-square-02.svg": 18212,
	"./Communication/message-x-square.svg": 76766,
	"./Communication/phone-call-01.svg": 27915,
	"./Communication/phone.svg": 7280,
	"./Communication/send-01.svg": 59062,
	"./Communication/send-03.svg": 57716,
	"./Development/brackets-check.svg": 15489,
	"./Development/brackets-ellipses.svg": 96734,
	"./Development/brackets-x.svg": 42681,
	"./Development/brackets.svg": 8306,
	"./Development/browser.svg": 88335,
	"./Development/code-01.svg": 5594,
	"./Development/code-02.svg": 50409,
	"./Development/code-browser.svg": 481,
	"./Development/code-circle-01.svg": 41713,
	"./Development/code-circle-03.svg": 88339,
	"./Development/code-square-01.svg": 70790,
	"./Development/container.svg": 94982,
	"./Development/cpu-chip-01.svg": 51460,
	"./Development/cpu-chip-02.svg": 94583,
	"./Development/data.svg": 77061,
	"./Development/database-01.svg": 68614,
	"./Development/database-02.svg": 67749,
	"./Development/database-03.svg": 13028,
	"./Development/dataflow-01.svg": 30999,
	"./Development/dataflow-02.svg": 87876,
	"./Development/dataflow-03.svg": 42597,
	"./Development/dataflow-04.svg": 47322,
	"./Development/file-code-01.svg": 3637,
	"./Development/file-code-02.svg": 90678,
	"./Development/folder-code.svg": 49149,
	"./Development/git-branch-01.svg": 70932,
	"./Development/git-commit.svg": 72831,
	"./Development/git-merge.svg": 4804,
	"./Development/package.svg": 18719,
	"./Development/puzzle-piece-01.svg": 34028,
	"./Development/puzzle-piece-02.svg": 89375,
	"./Development/server-01.svg": 27408,
	"./Development/server-02.svg": 33155,
	"./Development/server-03.svg": 29842,
	"./Development/server-04.svg": 63773,
	"./Development/server-05.svg": 35228,
	"./Development/terminal-browser.svg": 93674,
	"./Development/terminal-square.svg": 88755,
	"./Development/terminal.svg": 6785,
	"./Editor/align-center.svg": 37672,
	"./Editor/align-justify.svg": 54193,
	"./Editor/align-left.svg": 86276,
	"./Editor/align-right.svg": 73675,
	"./Editor/attachment-01.svg": 23108,
	"./Editor/attachment-02.svg": 66231,
	"./Editor/bezier-curve-01.svg": 22220,
	"./Editor/bold-01.svg": 94514,
	"./Editor/bold-02.svg": 99553,
	"./Editor/brush-01.svg": 65559,
	"./Editor/brush-02.svg": 22436,
	"./Editor/brush-03.svg": 77157,
	"./Editor/circle-cut.svg": 52420,
	"./Editor/code-snippet-01.svg": 97148,
	"./Editor/code-snippet-02.svg": 99471,
	"./Editor/colors.svg": 26539,
	"./Editor/command.svg": 50606,
	"./Editor/contrast-01.svg": 19479,
	"./Editor/contrast-02.svg": 76356,
	"./Editor/contrast-03.svg": 31077,
	"./Editor/crop-01.svg": 96587,
	"./Editor/crop-02.svg": 57752,
	"./Editor/cursor-02.svg": 6512,
	"./Editor/cursor-04.svg": 80254,
	"./Editor/cursor-box.svg": 43857,
	"./Editor/cursor-click-01.svg": 24658,
	"./Editor/cursor-click-02.svg": 17793,
	"./Editor/delete.svg": 66182,
	"./Editor/dotpoints-01.svg": 18131,
	"./Editor/dotpoints-02.svg": 57120,
	"./Editor/drop.svg": 8716,
	"./Editor/dropper.svg": 193,
	"./Editor/eraser.svg": 47359,
	"./Editor/feather.svg": 61736,
	"./Editor/figma.svg": 74537,
	"./Editor/framer.svg": 58460,
	"./Editor/hand.svg": 70112,
	"./Editor/heading-01.svg": 63033,
	"./Editor/heading-02.svg": 37034,
	"./Editor/image-indent-left.svg": 6189,
	"./Editor/image-indent-right.svg": 89648,
	"./Editor/italic-01.svg": 25457,
	"./Editor/italic-02.svg": 45058,
	"./Editor/magic-wand-01.svg": 51857,
	"./Editor/magic-wand-02.svg": 97314,
	"./Editor/move.svg": 21012,
	"./Editor/palette.svg": 21344,
	"./Editor/pen-tool-02.svg": 20118,
	"./Editor/pen-tool-minus.svg": 86780,
	"./Editor/pen-tool-plus.svg": 69524,
	"./Editor/pencil-01.svg": 15536,
	"./Editor/pencil-02.svg": 77027,
	"./Editor/pencil-line.svg": 13723,
	"./Editor/perspective-01.svg": 41177,
	"./Editor/perspective-02.svg": 15178,
	"./Editor/reflect-01.svg": 35446,
	"./Editor/reflect-02.svg": 76693,
	"./Editor/right-indent-01.svg": 96474,
	"./Editor/roller-brush.svg": 6460,
	"./Editor/scale-01.svg": 69525,
	"./Editor/scale-02.svg": 11926,
	"./Editor/scale-03.svg": 99047,
	"./Editor/scissors-02.svg": 60513,
	"./Editor/skew.svg": 13013,
	"./Editor/strikethrough-01.svg": 86608,
	"./Editor/strikethrough-02.svg": 43651,
	"./Editor/subscript.svg": 53718,
	"./Editor/text-input.svg": 60445,
	"./Editor/transform.svg": 53913,
	"./Editor/type-01.svg": 38289,
	"./Editor/type-02.svg": 17922,
	"./Editor/underline-01.svg": 15251,
	"./Editor/underline-02.svg": 24512,
	"./Editor/zoom-in.svg": 63010,
	"./Editor/zoom-out.svg": 44693,
	"./Education/atom-01.svg": 52487,
	"./Education/award-02.svg": 92012,
	"./Education/award-03.svg": 27469,
	"./Education/award-04.svg": 18178,
	"./Education/award-05.svg": 48755,
	"./Education/beaker-02.svg": 73963,
	"./Education/book-closed.svg": 81986,
	"./Education/book-open-01.svg": 27054,
	"./Education/briefcase-01.svg": 34222,
	"./Education/briefcase-02.svg": 44941,
	"./Education/calculator.svg": 37146,
	"./Education/certificate-01.svg": 35933,
	"./Education/certificate-02.svg": 23838,
	"./Education/compass.svg": 99566,
	"./Education/glasses-01.svg": 68822,
	"./Education/glasses-02.svg": 5461,
	"./Education/globe-slated-02.svg": 34894,
	"./Education/graduation-hat-02.svg": 69933,
	"./Education/microscope.svg": 81002,
	"./Education/ruler.svg": 58474,
	"./Education/stand.svg": 6110,
	"./Education/telescope.svg": 93838,
	"./Education/trophy-01.svg": 49956,
	"./Files/box.svg": 22614,
	"./Files/clipboard-attachment.svg": 84291,
	"./Files/clipboard-check.svg": 45220,
	"./Files/clipboard-download.svg": 74324,
	"./Files/clipboard-minus.svg": 89204,
	"./Files/clipboard-plus.svg": 19260,
	"./Files/clipboard-x.svg": 55324,
	"./Files/clipboard.svg": 89795,
	"./Files/file-03.svg": 12397,
	"./Files/file-04.svg": 54082,
	"./Files/file-05.svg": 16723,
	"./Files/file-07.svg": 8625,
	"./Files/file-attachment-03.svg": 59793,
	"./Files/file-attachment-04.svg": 50798,
	"./Files/file-check-02.svg": 7693,
	"./Files/file-check-03.svg": 27980,
	"./Files/file-download-02.svg": 66653,
	"./Files/file-download-03.svg": 77180,
	"./Files/file-plus-02.svg": 29921,
	"./Files/file-plus-03.svg": 94384,
	"./Files/file-question-02.svg": 38181,
	"./Files/file-question-03.svg": 83460,
	"./Files/file-search-02.svg": 45237,
	"./Files/file-search-03.svg": 19604,
	"./Files/file-x-02.svg": 46105,
	"./Files/file-x-03.svg": 64360,
	"./Files/folder-check.svg": 50064,
	"./Files/folder-closed.svg": 18952,
	"./Files/folder-download.svg": 96280,
	"./Files/folder-lock.svg": 51117,
	"./Files/folder-minus.svg": 6416,
	"./Files/folder-plus.svg": 84568,
	"./Files/folder-question.svg": 3284,
	"./Files/folder-search.svg": 42452,
	"./Files/folder-x.svg": 27536,
	"./Files/folder.svg": 90159,
	"./Files/paperclip.svg": 90989,
	"./Finance & eCommerce/bank-note-01.svg": 56765,
	"./Finance & eCommerce/bank-note-03.svg": 65167,
	"./Finance & eCommerce/bank.svg": 92274,
	"./Finance & eCommerce/coins-01.svg": 72846,
	"./Finance & eCommerce/coins-02.svg": 1965,
	"./Finance & eCommerce/coins-hand.svg": 83480,
	"./Finance & eCommerce/coins-stacked-01.svg": 49106,
	"./Finance & eCommerce/coins-stacked-02.svg": 42241,
	"./Finance & eCommerce/credit-card-02.svg": 9785,
	"./Finance & eCommerce/cryptocurrency-01.svg": 98078,
	"./Finance & eCommerce/cryptocurrency-02.svg": 10173,
	"./Finance & eCommerce/cryptocurrency-03.svg": 81628,
	"./Finance & eCommerce/cryptocurrency-04.svg": 9283,
	"./Finance & eCommerce/currency-dollar-circle.svg": 83061,
	"./Finance & eCommerce/currency-dollar.svg": 70216,
	"./Finance & eCommerce/currency-euro-circle.svg": 41422,
	"./Finance & eCommerce/currency-euro.svg": 56209,
	"./Finance & eCommerce/currency-pound-circle.svg": 82605,
	"./Finance & eCommerce/currency-pound.svg": 8128,
	"./Finance & eCommerce/currency-ruble-circle.svg": 74081,
	"./Finance & eCommerce/currency-ruble.svg": 58228,
	"./Finance & eCommerce/currency-rupee-circle.svg": 35610,
	"./Finance & eCommerce/currency-rupee.svg": 67533,
	"./Finance & eCommerce/currency-yen-circle.svg": 30007,
	"./Finance & eCommerce/currency-yen.svg": 97226,
	"./Finance & eCommerce/diamond-01.svg": 82992,
	"./Finance & eCommerce/gift-01.svg": 26122,
	"./Finance & eCommerce/gift-02.svg": 86873,
	"./Finance & eCommerce/piggy-bank-01.svg": 76593,
	"./Finance & eCommerce/receipt-check.svg": 52463,
	"./Finance & eCommerce/receipt.svg": 15916,
	"./Finance & eCommerce/safe.svg": 25999,
	"./Finance & eCommerce/sale-01.svg": 33015,
	"./Finance & eCommerce/sale-02.svg": 89892,
	"./Finance & eCommerce/sale-03.svg": 41061,
	"./Finance & eCommerce/sale-04.svg": 79962,
	"./Finance & eCommerce/scales-01.svg": 49055,
	"./Finance & eCommerce/scales-02.svg": 70028,
	"./Finance & eCommerce/shopping-bag-01.svg": 68439,
	"./Finance & eCommerce/shopping-bag-02.svg": 63844,
	"./Finance & eCommerce/shopping-cart-01.svg": 85273,
	"./Finance & eCommerce/shopping-cart-03.svg": 88443,
	"./Finance & eCommerce/tag-01.svg": 54900,
	"./Finance & eCommerce/tag-02.svg": 3111,
	"./Finance & eCommerce/wallet-02.svg": 96562,
	"./General/activity-heart.svg": 35624,
	"./General/activity.svg": 35963,
	"./General/anchor.svg": 31175,
	"./General/archive.svg": 28190,
	"./General/asterisk-01.svg": 99908,
	"./General/asterisk-02.svg": 54359,
	"./General/at-sign.svg": 17607,
	"./General/bookmark-add.svg": 30778,
	"./General/bookmark-check.svg": 41463,
	"./General/bookmark.svg": 80036,
	"./General/building-02.svg": 6075,
	"./General/building-04.svg": 66357,
	"./General/building-05.svg": 28372,
	"./General/building-06.svg": 92935,
	"./General/building-07.svg": 29718,
	"./General/building-08.svg": 3489,
	"./General/check-circle-broken.svg": 98153,
	"./General/check-circle.svg": 17889,
	"./General/check-done-01.svg": 11099,
	"./General/check-done-02.svg": 76712,
	"./General/check-heart.svg": 30227,
	"./General/check-square-broken.svg": 46614,
	"./General/check-square.svg": 56132,
	"./General/check-verified-01.svg": 50571,
	"./General/check-verified-02.svg": 11736,
	"./General/check-verified-03.svg": 46601,
	"./General/check.svg": 27476,
	"./General/cloud-blank-01.svg": 43802,
	"./General/copy-01.svg": 80837,
	"./General/copy-02.svg": 44614,
	"./General/copy-03.svg": 7415,
	"./General/copy-04.svg": 12344,
	"./General/copy-05.svg": 87849,
	"./General/copy-06.svg": 45914,
	"./General/copy-07.svg": 51179,
	"./General/divide-02.svg": 86634,
	"./General/divide-03.svg": 4475,
	"./General/download-01.svg": 49360,
	"./General/download-02.svg": 10851,
	"./General/download-03.svg": 72914,
	"./General/download-cloud-01.svg": 30444,
	"./General/edit-01.svg": 60228,
	"./General/edit-02.svg": 64823,
	"./General/edit-03.svg": 2022,
	"./General/edit-04.svg": 28905,
	"./General/edit-05.svg": 69752,
	"./General/equal-not.svg": 90748,
	"./General/equal.svg": 4884,
	"./General/eye-off.svg": 52731,
	"./General/eye.svg": 71859,
	"./General/filter-funnel-01.svg": 60657,
	"./General/filter-funnel-02.svg": 3554,
	"./General/filter-lines.svg": 76544,
	"./General/google-chrome.svg": 57672,
	"./General/hash-01.svg": 27944,
	"./General/hash-02.svg": 9307,
	"./General/heart-circle.svg": 26413,
	"./General/heart-hand.svg": 75050,
	"./General/heart-rounded.svg": 66892,
	"./General/heart-square.svg": 15264,
	"./General/hearts.svg": 97603,
	"./General/help-circle.svg": 86778,
	"./General/help-hexagon.svg": 61614,
	"./General/help-octagon.svg": 11995,
	"./General/help-square.svg": 97023,
	"./General/home-01.svg": 43183,
	"./General/home-02.svg": 64156,
	"./General/home-03.svg": 53629,
	"./General/home-line.svg": 79200,
	"./General/info-circle.svg": 98157,
	"./General/info-hexagon.svg": 69471,
	"./General/info-octagon.svg": 74302,
	"./General/info-square.svg": 83904,
	"./General/life-buoy-01.svg": 1796,
	"./General/link-01.svg": 9880,
	"./General/link-02.svg": 48715,
	"./General/link-03.svg": 43450,
	"./General/link-broken-01.svg": 36574,
	"./General/link-broken-02.svg": 90749,
	"./General/link-external-01.svg": 3532,
	"./General/link-external-02.svg": 82559,
	"./General/loading-01.svg": 78948,
	"./General/loading-02.svg": 33399,
	"./General/loading-03.svg": 44422,
	"./General/log-in-01.svg": 8406,
	"./General/log-in-02.svg": 49653,
	"./General/log-out-01.svg": 33735,
	"./General/medical-circle.svg": 33974,
	"./General/medical-cross.svg": 27198,
	"./General/medical-square.svg": 9867,
	"./General/menu-01.svg": 94007,
	"./General/minus-circle.svg": 23921,
	"./General/minus-square.svg": 17652,
	"./General/minus.svg": 28868,
	"./General/percent-02.svg": 52602,
	"./General/percent-03.svg": 71659,
	"./General/pin-01.svg": 64319,
	"./General/pin-02.svg": 85292,
	"./General/placeholder.svg": 99475,
	"./General/plus-circle.svg": 47737,
	"./General/plus-square.svg": 63740,
	"./General/plus.svg": 13100,
	"./General/save-01.svg": 77949,
	"./General/search-md.svg": 39258,
	"./General/search-refraction.svg": 81652,
	"./General/search-sm.svg": 68017,
	"./General/settings-01.svg": 88261,
	"./General/settings-04.svg": 91032,
	"./General/share-01.svg": 33835,
	"./General/share-05.svg": 90071,
	"./General/share-06.svg": 85476,
	"./General/share-07.svg": 63493,
	"./General/slash-circle-01.svg": 78792,
	"./General/slash-divider.svg": 54067,
	"./General/speedometer-01.svg": 65085,
	"./General/speedometer-03.svg": 54639,
	"./General/target-04.svg": 48452,
	"./General/target-05.svg": 45701,
	"./General/toggle-02-left.svg": 56107,
	"./General/toggle-02-right.svg": 66446,
	"./General/tool-01.svg": 39682,
	"./General/tool-02.svg": 10577,
	"./General/translate-01.svg": 82542,
	"./General/translate-02.svg": 14541,
	"./General/trash-01.svg": 55314,
	"./General/trash-02.svg": 48449,
	"./General/upload-01.svg": 73761,
	"./General/upload-02.svg": 8370,
	"./General/upload-03.svg": 41411,
	"./General/upload-cloud-01.svg": 88965,
	"./General/virus.svg": 15155,
	"./General/x-circle.svg": 62585,
	"./General/x-close.svg": 83619,
	"./General/x-square.svg": 36828,
	"./General/zap-circle.svg": 83318,
	"./General/zap-fast.svg": 89160,
	"./General/zap-square.svg": 13483,
	"./General/zap.svg": 39257,
	"./Images/camera-01.svg": 91503,
	"./Images/camera-02.svg": 89180,
	"./Images/colors.svg": 2352,
	"./Images/flash.svg": 96730,
	"./Images/image-01.svg": 67805,
	"./Images/image-02.svg": 13630,
	"./Images/image-03.svg": 76207,
	"./Images/image-05.svg": 38913,
	"./Images/image-check.svg": 46580,
	"./Images/image-plus.svg": 56012,
	"./Images/image-user-check.svg": 84114,
	"./Images/image-user-plus.svg": 82502,
	"./Images/image-user-x.svg": 82918,
	"./Images/image-user.svg": 38157,
	"./Images/image-x.svg": 37228,
	"./InstallMethods/AdobeCommerceOrMagento.svg": 69087,
	"./InstallMethods/BigCommerce.svg": 33864,
	"./InstallMethods/Direct.svg": 42310,
	"./InstallMethods/Drupal.svg": 63631,
	"./InstallMethods/Framer.svg": 25666,
	"./InstallMethods/GoDaddy.svg": 52003,
	"./InstallMethods/GoogleTagManager.svg": 84457,
	"./InstallMethods/HubSpot.svg": 6430,
	"./InstallMethods/Joomla.svg": 74713,
	"./InstallMethods/Shopify.svg": 84293,
	"./InstallMethods/Squarespace.svg": 36902,
	"./InstallMethods/Volusion.svg": 69994,
	"./InstallMethods/Webflow.svg": 55293,
	"./InstallMethods/Weebly.svg": 83973,
	"./InstallMethods/Wix.svg": 41447,
	"./InstallMethods/WooCommerce.svg": 9591,
	"./InstallMethods/WordPress.svg": 96186,
	"./Layout/align-bottom-01.svg": 4903,
	"./Layout/align-horizontal-centre-01.svg": 28304,
	"./Layout/align-left-01.svg": 15941,
	"./Layout/align-right-01.svg": 20686,
	"./Layout/align-top-01.svg": 76223,
	"./Layout/align-top-02.svg": 97196,
	"./Layout/align-vertical-center-01.svg": 46608,
	"./Layout/columns-01.svg": 12095,
	"./Layout/columns-02.svg": 56748,
	"./Layout/columns-03.svg": 36461,
	"./Layout/divider.svg": 26283,
	"./Layout/flex-align-left.svg": 79977,
	"./Layout/flex-align-right.svg": 77428,
	"./Layout/grid-01.svg": 30924,
	"./Layout/grid-02.svg": 86271,
	"./Layout/grid-03.svg": 81518,
	"./Layout/grid-dots-blank.svg": 6752,
	"./Layout/grid-dots-outer.svg": 2627,
	"./Layout/intersect-circle.svg": 40916,
	"./Layout/intersect-square.svg": 74557,
	"./Layout/layer-single.svg": 85236,
	"./Layout/layers-three-01.svg": 17695,
	"./Layout/layers-three-02.svg": 45996,
	"./Layout/layers-two-01.svg": 39109,
	"./Layout/layers-two-02.svg": 7334,
	"./Layout/layout-alt-01.svg": 2140,
	"./Layout/layout-alt-02.svg": 81167,
	"./Layout/layout-alt-03.svg": 37438,
	"./Layout/layout-alt-04.svg": 50817,
	"./Layout/layout-grid-01.svg": 83825,
	"./Layout/layout-grid-02.svg": 63458,
	"./Layout/layout-left.svg": 98044,
	"./Layout/layout-right.svg": 55779,
	"./Layout/layout-top.svg": 86208,
	"./Layout/list.svg": 18504,
	"./Layout/maximize-01.svg": 26470,
	"./Layout/maximize-02.svg": 62693,
	"./Layout/minimize-01.svg": 50524,
	"./Layout/rows-02.svg": 56362,
	"./Layout/rows-03.svg": 90555,
	"./Layout/spacing-height-01.svg": 35371,
	"./Layout/spacing-width-01.svg": 33564,
	"./Layout/table.svg": 676,
	"./Maps & travel/bus.svg": 34115,
	"./Maps & travel/car-01.svg": 31861,
	"./Maps & travel/car-02.svg": 11574,
	"./Maps & travel/compass-03.svg": 6929,
	"./Maps & travel/flag-01.svg": 25435,
	"./Maps & travel/flag-02.svg": 44072,
	"./Maps & travel/flag-03.svg": 51993,
	"./Maps & travel/flag-06.svg": 76020,
	"./Maps & travel/globe-01.svg": 36958,
	"./Maps & travel/globe-02.svg": 91133,
	"./Maps & travel/globe-03.svg": 1660,
	"./Maps & travel/globe-04.svg": 71843,
	"./Maps & travel/globe-05.svg": 57202,
	"./Maps & travel/globe-06.svg": 50337,
	"./Maps & travel/luggage-03.svg": 1853,
	"./Maps & travel/map-01.svg": 965,
	"./Maps & travel/map-02.svg": 1830,
	"./Maps & travel/marker-pin-01.svg": 52473,
	"./Maps & travel/marker-pin-05.svg": 84309,
	"./Maps & travel/marker-pin-06.svg": 12438,
	"./Maps & travel/navigation-pointer-01.svg": 14207,
	"./Maps & travel/navigation-pointer-02.svg": 35180,
	"./Maps & travel/plane.svg": 87615,
	"./Maps & travel/rocket-02.svg": 76954,
	"./Maps & travel/route.svg": 6858,
	"./Maps & travel/ticket-01.svg": 857,
	"./Maps & travel/train.svg": 24147,
	"./Maps & travel/tram.svg": 63771,
	"./Maps & travel/truck-01.svg": 27380,
	"./Maps & travel/truck-02.svg": 98887,
	"./Media & devices/airplay.svg": 44501,
	"./Media & devices/airpods.svg": 21555,
	"./Media & devices/battery-charging-01.svg": 16728,
	"./Media & devices/battery-full.svg": 28434,
	"./Media & devices/battery-low.svg": 4009,
	"./Media & devices/bluetooth-connect.svg": 75732,
	"./Media & devices/bluetooth-on.svg": 42125,
	"./Media & devices/chrome-cast.svg": 21385,
	"./Media & devices/clapperboard.svg": 19088,
	"./Media & devices/disc-02.svg": 85457,
	"./Media & devices/fast-backward.svg": 72687,
	"./Media & devices/fast-forward.svg": 88571,
	"./Media & devices/film-01.svg": 77517,
	"./Media & devices/film-02.svg": 48398,
	"./Media & devices/film-03.svg": 69503,
	"./Media & devices/gaming-pad-01.svg": 3258,
	"./Media & devices/gaming-pad-02.svg": 71369,
	"./Media & devices/hard-drive.svg": 95797,
	"./Media & devices/headphones-01.svg": 34480,
	"./Media & devices/keyboard-01.svg": 93610,
	"./Media & devices/keyboard-02.svg": 42905,
	"./Media & devices/laptop-01.svg": 63207,
	"./Media & devices/laptop-02.svg": 75348,
	"./Media & devices/lightbulb-01.svg": 42050,
	"./Media & devices/lightbulb-02.svg": 22449,
	"./Media & devices/lightbulb-03.svg": 65536,
	"./Media & devices/microphone-01.svg": 95251,
	"./Media & devices/microphone-off-01.svg": 66743,
	"./Media & devices/modem-02.svg": 28576,
	"./Media & devices/monitor-01.svg": 15571,
	"./Media & devices/monitor-03.svg": 81745,
	"./Media & devices/mouse.svg": 58790,
	"./Media & devices/music-note-01.svg": 54537,
	"./Media & devices/music-note-02.svg": 12602,
	"./Media & devices/pause-circle.svg": 62986,
	"./Media & devices/pause-square.svg": 20495,
	"./Media & devices/phone-01.svg": 93681,
	"./Media & devices/phone-02.svg": 73314,
	"./Media & devices/play-circle.svg": 49812,
	"./Media & devices/play-square.svg": 30973,
	"./Media & devices/play.svg": 48119,
	"./Media & devices/podcast.svg": 46247,
	"./Media & devices/power-01.svg": 58972,
	"./Media & devices/power-02.svg": 37999,
	"./Media & devices/printer.svg": 47931,
	"./Media & devices/recording-01.svg": 233,
	"./Media & devices/recording-02.svg": 35573,
	"./Media & devices/repeat-01.svg": 11332,
	"./Media & devices/repeat-02.svg": 15927,
	"./Media & devices/repeat-03.svg": 53126,
	"./Media & devices/repeat-04.svg": 96361,
	"./Media & devices/rss-01.svg": 30177,
	"./Media & devices/rss-02.svg": 25138,
	"./Media & devices/shuffle-01.svg": 53903,
	"./Media & devices/signal-01.svg": 74971,
	"./Media & devices/signal-02.svg": 93608,
	"./Media & devices/signal-03.svg": 59001,
	"./Media & devices/simcard.svg": 79628,
	"./Media & devices/skip-back.svg": 16436,
	"./Media & devices/skip-forward.svg": 72864,
	"./Media & devices/sliders-01.svg": 56739,
	"./Media & devices/sliders-02.svg": 99696,
	"./Media & devices/sliders-03.svg": 35233,
	"./Media & devices/sliders-04.svg": 21854,
	"./Media & devices/speaker-01.svg": 79408,
	"./Media & devices/stop-circle.svg": 99858,
	"./Media & devices/tablet-01.svg": 11107,
	"./Media & devices/tablet-02.svg": 54064,
	"./Media & devices/tv-03.svg": 42843,
	"./Media & devices/usb-flash-drive.svg": 1323,
	"./Media & devices/video-recorder-off.svg": 29957,
	"./Media & devices/video-recorder.svg": 79025,
	"./Media & devices/voicemail.svg": 2492,
	"./Media & devices/volume-max.svg": 91046,
	"./Media & devices/volume-min.svg": 22592,
	"./Media & devices/volume-minus.svg": 3796,
	"./Media & devices/volume-plus.svg": 94076,
	"./Media & devices/volume-x.svg": 60764,
	"./Media & devices/webcam-01.svg": 36242,
	"./Media & devices/webcam-02.svg": 41281,
	"./Media & devices/wifi-off.svg": 88558,
	"./Media & devices/wifi.svg": 19886,
	"./Media & devices/youtube.svg": 86572,
	"./Security/face-id-square.svg": 68301,
	"./Security/face-id.svg": 65991,
	"./Security/file-lock-02.svg": 81149,
	"./Security/file-lock-03.svg": 10524,
	"./Security/file-shield-02.svg": 6447,
	"./Security/file-shield-03.svg": 86398,
	"./Security/fingerprint-03.svg": 4710,
	"./Security/folder-shield.svg": 73546,
	"./Security/key-01.svg": 80703,
	"./Security/key-02.svg": 1676,
	"./Security/lock-01.svg": 67943,
	"./Security/lock-03.svg": 22069,
	"./Security/lock-keyhole-circle.svg": 15546,
	"./Security/lock-unlocked-01.svg": 48651,
	"./Security/lock-unlocked-03.svg": 44681,
	"./Security/passcode-lock.svg": 68756,
	"./Security/passcode.svg": 24724,
	"./Security/scan.svg": 13095,
	"./Security/shield-01.svg": 51201,
	"./Security/shield-dollar.svg": 32762,
	"./Security/shield-off.svg": 18095,
	"./Security/shield-plus.svg": 48048,
	"./Security/shield-tick.svg": 3047,
	"./Security/shield-zap.svg": 91061,
	"./Shapes/circle.svg": 99988,
	"./Shapes/cube-01.svg": 78025,
	"./Shapes/cube-03.svg": 10731,
	"./Shapes/cube-04.svg": 43140,
	"./Shapes/hexagon-01.svg": 35648,
	"./Shapes/hexagon-02.svg": 26387,
	"./Shapes/octagon.svg": 19689,
	"./Shapes/pentagon.svg": 50956,
	"./Shapes/square.svg": 86717,
	"./Shapes/star-01.svg": 25996,
	"./Shapes/star-02.svg": 88671,
	"./Shapes/star-03.svg": 74030,
	"./Shapes/star-04.svg": 85585,
	"./Shapes/star-05.svg": 87552,
	"./Shapes/star-06.svg": 32211,
	"./Shapes/triangle.svg": 4356,
	"./Time/alarm-clock-check.svg": 4452,
	"./Time/alarm-clock.svg": 65731,
	"./Time/calendar-check-01.svg": 39710,
	"./Time/calendar-check-02.svg": 93885,
	"./Time/calendar-date.svg": 54674,
	"./Time/calendar.svg": 54409,
	"./Time/clock-check.svg": 19804,
	"./Time/clock-refresh.svg": 77274,
	"./Time/clock-stopwatch.svg": 25693,
	"./Time/clock.svg": 53579,
	"./Time/hourglass-01.svg": 72405,
	"./Time/hourglass-03.svg": 98983,
	"./Time/watch-circle.svg": 64521,
	"./Time/watch-square.svg": 75948,
	"./Users/face-frown.svg": 41384,
	"./Users/face-happy.svg": 50898,
	"./Users/face-neutral.svg": 16181,
	"./Users/face-smile.svg": 73452,
	"./Users/user-01.svg": 69339,
	"./Users/user-check-02.svg": 22553,
	"./Users/user-circle.svg": 9346,
	"./Users/user-down-02.svg": 41681,
	"./Users/user-edit.svg": 97278,
	"./Users/user-left-02.svg": 71964,
	"./Users/user-minus-02.svg": 65733,
	"./Users/user-plus-02.svg": 29901,
	"./Users/user-right-02.svg": 60179,
	"./Users/user-up-02.svg": 708,
	"./Users/user-x-02.svg": 73917,
	"./Users/users-01.svg": 96744,
	"./Users/users-03.svg": 36138,
	"./Weather/cloud-01.svg": 60497,
	"./Weather/cloud-02.svg": 89602,
	"./Weather/cloud-lightning.svg": 75582,
	"./Weather/cloud-moon.svg": 60523,
	"./Weather/cloud-raining-04.svg": 84019,
	"./Weather/cloud-raining-05.svg": 96642,
	"./Weather/cloud-snowing-02.svg": 67394,
	"./Weather/cloud-sun-01.svg": 60426,
	"./Weather/cloud-sun-02.svg": 9721,
	"./Weather/droplets-01.svg": 74675,
	"./Weather/hurricane-01.svg": 65095,
	"./Weather/hurricane-02.svg": 93588,
	"./Weather/lightning-01.svg": 69034,
	"./Weather/lightning-02.svg": 29785,
	"./Weather/moon-01.svg": 49625,
	"./Weather/moon-02.svg": 5226,
	"./Weather/moon-star.svg": 19496,
	"./Weather/snowflake-01.svg": 29636,
	"./Weather/snowflake-02.svg": 34231,
	"./Weather/stars-01.svg": 12209,
	"./Weather/stars-02.svg": 57666,
	"./Weather/sun-setting-01.svg": 49679,
	"./Weather/sun-setting-02.svg": 47356,
	"./Weather/sun.svg": 43974,
	"./Weather/umbrella-02.svg": 2767,
	"./Weather/umbrella-03.svg": 40190,
	"./Weather/waves.svg": 17798,
	"./Weather/wind-01.svg": 34262,
	"./Weather/wind-02.svg": 22485,
	"./Weather/wind-03.svg": 49876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61984;